/*
  kult-zeitung.js — weiche Leseschranke der Kult Kaffeezeitung für Gäste (snippets/kult-zeitung-gate.liquid).
  Gibt den verborgenen Volltext frei, wenn
  (a) das Anmeldeformular ohne Seitenwechsel erfolgreich gesendet wurde (Ereignis „kult:send:success“ von assets/kult-send.js
      am Gate; die Erfolgsmeldung [data-kult-gate-posted] steht immer versteckt im Formular und löst beim Laden nichts aus),
  (b) der Merker localStorage['kult:zeitung-leser'] gesetzt ist oder
  (c) die URL den Parameter nl trägt (Links aus dem Newsletter: ?nl=<ausgabe>).
  (a) und (c) setzen den Merker. Bei (a) bleibt der Kasten mit der Erfolgsmeldung sichtbar (Fokus darauf), bei (b)/(c)
  wird er ausgeblendet. Der Parameter nl wird danach aus der Adresszeile entfernt, damit geteilte Links
  nicht freischalten. Ohne JS bleibt der Beitrag angeteasert und das Formular zeigt einen Hinweis.
*/
(() => {
  const KEY = 'kult:zeitung-leser';
  const gate = document.querySelector('[data-kult-gate="guest"]');
  const full = document.querySelector('[data-kult-gate-full]');
  if (!gate || !full) return;

  const read = () => {
    try { return window.localStorage.getItem(KEY); } catch (e) { return null; }
  };
  const write = (value) => {
    try { window.localStorage.setItem(KEY, value); } catch (e) { /* privater Modus: nur diese Ansicht frei */ }
  };

  const teaser = gate.querySelector('[data-kult-gate-teaser]');
  const box = gate.querySelector('[data-kult-gate-box]');
  const posted = gate.querySelector('[data-kult-gate-posted]');

  const open = () => {
    if (teaser) teaser.hidden = true;
    full.hidden = false;
    gate.dataset.state = 'open';
  };

  // Anmeldung gerade erfolgreich (kult-send.js): Merker setzen, Volltext freigeben, Bestätigung bleibt im Kasten stehen.
  gate.addEventListener('kult:send:success', () => {
    write('anmeldung');
    open();
    if (posted) posted.focus({ preventScroll: false });
  });

  const url = new URL(window.location.href);
  const issue = url.searchParams.get('nl');

  if (issue !== null) {
    write('nl:' + (issue || '1'));
    url.searchParams.delete('nl');
    try { window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash); } catch (e) { /* egal */ }
  }

  if (issue === null && !read()) return;

  // Schon Leser:in (Merker oder Newsletter-Link): Kasten weg, Volltext offen.
  if (box) box.hidden = true;
  open();
})();
